// extracted by mini-css-extract-plugin
export var container = "_6o-0";
export var fallback = "_6o-5";
export var fallbackIcon = "_6o-6";
export var hidden = "_6o-2";
export var image = "_6o-3";
export var loaded = "_6o-4";
export var placeholder = "_6o-1";